export default __webpack_public_path__ + "static/media/alarm-clock.c02a5d05.ttf";